function boxIndices(sourceSize, size, factor) {
    const targetOf = new Int32Array(sourceSize);
    const counts = new Int32Array(size);
    for (let index = 0; index < sourceSize; index++) {
        const target = Math.min((index / factor) | 0, size - 1);
        targetOf[index] = target;
        counts[target]++;
    }
    return { targetOf, counts };
}
export default function fillPlaneByAverage(frames, [sourceWidth, sourceHeight], [width, height], [factorI, factorJ], values) {
    if (!frames.length) {
        for (let index = 0; index < width * height; index++) {
            values[index] = 0;
        }
        return;
    }
    const columns = boxIndices(sourceWidth, width, factorI);
    const rows = boxIndices(sourceHeight, height, factorJ);
    const round = !(values instanceof Float32Array || values instanceof Float64Array);
    const { targetOf } = columns;
    const sums = new Float64Array(width);
    let sourceRow = 0;
    for (let j = 0; j < height; j++) {
        const rowCount = rows.counts[j];
        sums.fill(0);
        for (const frame of frames) {
            for (let row = sourceRow; row < sourceRow + rowCount; row++) {
                const start = row * sourceWidth;
                for (let i = 0; i < sourceWidth; i++) {
                    sums[targetOf[i]] += frame[start + i];
                }
            }
        }
        const boxRows = rowCount * frames.length;
        const targetRow = j * width;
        for (let i = 0; i < width; i++) {
            const count = columns.counts[i] * boxRows;
            const value = count ? sums[i] / count : 0;
            values[targetRow + i] = round ? Math.round(value) : value;
        }
        sourceRow += rowCount;
    }
}
